<template>
    <div>
      <Head title="Reports" />
      <h1 class="mb-8 text-3xl font-bold">User Report
            <downloadexcel
            :data="users"
            :fields="user_fields"
          >
          <v-btn large color="primary">Download <v-icon>mdi-download</v-icon></v-btn>
          </downloadexcel>
        </h1>
      
          
        <v-data-table
        :items="users"
        :headers="headers"
        >

            

            <template v-slot:item.contract_types_fulltime="{ item }">
                <v-icon v-if="hasContractType(item.contract_types,'Full-time')" color="green">mdi-check</v-icon>
            </template>
            <template v-slot:item.contract_types_parttime="{ item }">
                <v-icon v-if="hasContractType(item.contract_types,'Part-time')" color="green">mdi-check</v-icon>
            </template>
            <template v-slot:item.contract_types_contract="{ item }">
                <v-icon v-if="hasContractType(item.contract_types,'Contract')" color="green">mdi-check</v-icon>
            </template>
            <template v-slot:item.contract_types_volunteer="{ item }">
                <v-icon v-if="hasContractType(item.contract_types,'Volunteer')" color="green">mdi-check</v-icon>
            </template>
            <template v-slot:item.contract_types_returnships="{ item }">
                <v-icon v-if="hasContractType(item.contract_types,'Returnships')" color="green">mdi-check</v-icon>
            </template>
            <template v-slot:item.contract_types_flexible="{ item }">
                <v-icon v-if="hasContractType(item.contract_types,'Flexible')" color="green">mdi-check</v-icon>
            </template>
            <template v-slot:item.contract_types_remote="{ item }">
                <v-icon v-if="hasContractType(item.contract_types,'Remote')" color="green">mdi-check</v-icon>
            </template>
        </v-data-table> 
      
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import { Link } from '@inertiajs/inertia-vue'
    import Layout from '@/Shared/VuetifyAdminLayout'
    import axios from 'axios'
    import downloadexcel  from "vue-json-excel";

  export default {
    components: {
      Head,
      downloadexcel,
      Link
    },
    props: {
      users: Array,
      categories: Array
      },
    /*computed: {
      reducedJobs() {
        let rj = JSON.parse(JSON.stringify(jobs));
        for(i=0;i<jobs.length;i++)
        {
          rj[i].organization_id = 
        }
      }
    },*/
    data: () => ({
      headers: [
        /*
        
User Email	User ID	First name	Last name	Username	Reg. Date	Age	Gender	Experience	Goals	Roles	CVs	Returning to...
Education	Work	Unsure
        */
              { text: 'Cat ID', value:'cat_id'},
              { text: 'Cat Title', value:'cat_title'},
              { text:'User ID', value:'user_id'},
              { text: 'Age', value:'age'},
              { text: 'Gender', value:'gender'},
              { text: 'Full-time', value:'contract_types_fulltime'},
              { text: 'Part-time', value:'contract_types_parttime'},
              { text: 'Remote', value:'contract_types_remote'},
              { text: 'Contract', value:'contract_types_contract'},
              { text: 'Returnships', value:'contract_types_returnships'},
              { text: 'Volunteer', value:'contract_types_volunteer'},
              { text: 'Flexible', value:'contract_types_flexible'},
        ],
        user_fields: {
            "Cat ID": "cat_id",
            "Cat Title": "cat_title",
            "User ID": "user_id",
            "Age": "age",
            "Gender": "gender",
            


            "Full-time": {
                field: 'contract_types',
                callback: (value) => {
                    let c = value.split(',');
                    let key = 'Full-time';
                    if (c.includes(key))
                        return 1
                    else
                        return 0
                }
            },
            "Part-time": {
                field: 'contract_types',
                callback: (value) => {
                    let c = value.split(',');
                    let key = 'Part-time';
                    if (c.includes(key))
                        return 1
                    else
                        return 0
                }
            },
            "Remote": {
                field: 'contract_types',
                callback: (value) => {
                    let c = value.split(',');
                    let key = 'Remote';
                    if (c.includes(key))
                        return 1
                    else
                        return 0
                }
            },
            "Returnships": {
                field: 'contract_types',
                callback: (value) => {
                    let c = value.split(',');
                    let key = 'Returnships';
                    if (c.includes(key))
                        return 1
                    else
                        return 0
                }
            },
            "Volunteer": {
                field: 'contract_types',
                callback: (value) => {
                    let c = value.split(',');
                    let key = 'Volunteer';
                    if (c.includes(key))
                        return 1
                    else
                        return 0
                }
            },
            "Flexible": {
                field: 'contract_types',
                callback: (value) => {
                    let c = value.split(',');
                    let key = 'Contract';
                    if (c.includes(key))
                        return 1
                    else
                        return 0
                }
            },
          
      },
    }),
    layout: Layout,
    created() {
        window.categories = this.categories;
        window.getCategories = this.getCategories
        window.getMetaValue = this.getMetaValue
    },
    methods: {
        hasContractType(cts,key)
        {
            let c = cts.split(',');
            console.log(c,cts,key);
            if (c.includes(key))
                return true
            else
                return false
        },
        prettyDate(x) {
            var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

            return new Date(x).toLocaleDateString(undefined,options)
        },
      getMetaValue(m,key) {
        var result = m.filter(obj => {
            return obj.meta_key === key
            });

        if (result && result.length == 1)
            return result[0].meta_value
        else if (result && result.length > 1)
            return result
        else
            return ''
      },

      getCategories(m,key)
      {
        var result = m.filter(obj => {
            return obj.meta_key === key
            });
        
        if (result)
        {
            var t = "";
            for(var i =0; i<result.length;i++)
            {
                let cid = result[i].meta_value;
                var cat_names = this.categories.filter(obj=> {
                    return obj.id == cid
                    });
                if (cat_names && cat_names[0])
                    t+= cat_names[0].title + ' // ';
            }
            return t;
        }
        else
            return result
      }
      
    },
  }
  </script>
  
  <style scoped>
    .v-sheet--offset {
      top: -24px;
      position: relative;
    }
  </style>